.page {
  padding: var(--hcr-spacing-4);
}
